import * as React from 'react';

import { cn } from '../../lib/utils';

const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-10 fhd:min-h-11 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm fhd:text-base',
        'resize-none overflow-y-auto overflow-x-hidden whitespace-pre-wrap break-words',
        className,
      )}
      {...props}
    />
  );
});
TextArea.displayName = 'TextArea';

export { TextArea };
